import { render, staticRenderFns } from "./CardBodyButton.vue?vue&type=template&id=1a45d77a"
import script from "./CardBodyButton.vue?vue&type=script&lang=ts"
export * from "./CardBodyButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a45d77a')) {
      api.createRecord('1a45d77a', component.options)
    } else {
      api.reload('1a45d77a', component.options)
    }
    module.hot.accept("./CardBodyButton.vue?vue&type=template&id=1a45d77a", function () {
      api.rerender('1a45d77a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardBodyButton.vue"
export default component.exports